import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Location } from 'lib/types';
import useGoogleAnalytics from 'analytics/hooks/useGoogleAnalytics';

type GooglePhoneConversionTrackingQuery = {
    allLocation: {
        nodes: ReadonlyArray<
            Pick<Location, 'phoneNumber' | 'googlePhoneConversionId'> & {
                id: string;
            }
        >;
    };
};

export const query = graphql`
    query GooglePhoneConversionTrackingQuery {
        allLocation(
            filter: {
                googlePhoneConversionId: { nin: ["", null] }
                phoneNumber: { nin: ["", null] }
            }
        ) {
            nodes {
                id
                phoneNumber
                googlePhoneConversionId
            }
        }
    }
`;

export default function useGooglePhoneConversionTracking(): void {
    const {
        allLocation: { nodes: locations },
    } = useStaticQuery<GooglePhoneConversionTrackingQuery>(query);
    const { trackWithAnyGoogleAnalytics } = useGoogleAnalytics();

    React.useEffect(() => {
        locations.forEach(({ googlePhoneConversionId, phoneNumber }) => {
            if (googlePhoneConversionId && phoneNumber) {
                trackWithAnyGoogleAnalytics(
                    false,
                    'config',
                    googlePhoneConversionId,
                    {
                        phone_conversion_number: phoneNumber,
                    },
                );
            }
        });
    }, [locations, trackWithAnyGoogleAnalytics]);
}
